import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  canPreview: boolean;
  workId: string;
};

export const PreviewButtons: FC<Props> = ({ canPreview, workId }) => {
  if (!canPreview) return null;

  return (
    <div className={styles.previewContainer}>
      <p className={styles.previewText}>下書き保存した内容をプレビュー</p>
      <ul className={styles.previewButtonsContainer}>
        <Button theme="tertiary" className={`${styles.previewButton} js-preview devise_pc`}>
          <Icon name="pc" />
          PC版
        </Button>
        <Button theme="tertiary" className={`${styles.previewButton} js-preview devise_sp`}>
          <Icon name="phone" />
          スマホ版
        </Button>
      </ul>
      <input type="hidden" name="id" id="id" value={workId} />
    </div>
  );
};
